<template>
  <v-tooltip bottom :disabled="!name">
    <template v-slot:activator="{ on, attrs }">
      <span
        v-on="on"
        v-bind="attrs"
      >
        <router-link
          :to="routerLinkTo"
          class="c-tablet-menu-entry bg-color-coro-lightgray"
          active-class="c-tablet-menu-entry__active"
          :exact="exact"
          v-if="enabled"
        >
          <v-icon class="c-tablet-menu-entry__icon">{{ icon }}</v-icon>
        </router-link>
        <div
          class="
            c-tablet-menu-entry
            c-tablet-menu-entry__disabled
            bg-color-coro-lightgray
          "
          v-else
        >
          <v-icon class="c-tablet-menu-entry__icon">{{ icon }}</v-icon>
        </div>
      </span>
    </template>
    {{ name }}
  </v-tooltip>
</template>

<script>

/**
 * Component TabletMenuEntry.vue
 *
 * @module TabletMenuEntry
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/APP_DASHBOARD/templates/components/Parts/TabletMenuEntry.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "TabletMenuEntry",
  props: {
    routerLinkTo: {
      type: Object,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    exact: {
      type: Boolean,
      default: () => false,
    },
    enabled: {
      type: Boolean,
      default: () => false,
    },
    name: {
      type: String
    }
  },
};
</script>

<style lang="scss">
// mobile first
.c-tablet-menu-entry {
  display: block;
  width: 52px;
  height: 52px;
  text-align: center;
  border-radius: 5px;
  text-decoration: none !important;
  margin-bottom: 24px;
}

.c-tablet-menu-entry__icon {
  line-height: 52px !important;
  color: rgba(0, 0, 0, 0.87);
  caret-color: rgba(0, 0, 0, 0.87);
}

.c-tablet-menu-entry__disabled {
    background-color: #F0F0F0 !important;
    cursor: not-allowed;

    .c-tablet-menu-entry__icon {
      color: rgba(0, 0, 0, 0.2);
      caret-color: rgba(0, 0, 0, 0.2);
    }
}

.c-tablet-menu-entry__active {
  background-color: #fdf9fa !important;

  .c-tablet-menu-entry__icon {
    color: rgb(174, 19, 42);
    caret-color: rgb(174, 19, 42);
  }
}

// mobile screens

// tablet screens

// desktop/large screens

// -------------------------------------------------- BEM modifiers ------------------------------------------------
</style>
